import {FC} from "react";
import {useOutletContext} from "react-router-dom";
import { UnityGoodsControlTabContent } from "./content";
import { Unity } from "../../../../domain/unity";

export const UnityGoodsControlTab: FC<any> = () => {
    const unity = useOutletContext<Unity>();
    return <UnityGoodsControlTabContent unity={unity}/>;
};
